import { render, staticRenderFns } from "./Descuento_editar.vue?vue&type=template&id=5f45c41b&scoped=true"
import script from "./Descuento_editar.vue?vue&type=script&lang=js"
export * from "./Descuento_editar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f45c41b",
  null
  
)

export default component.exports